import { MudarPerfilComponent } from './components/shared/mudar-perfil/mudar-perfil.component';
import { EntregaslistComponent } from './components/participante/entregaslist/entregaslist.component';
import { LoginComponent } from './components/shared/login/login.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DetalhesComponent } from './components/detalhes/detalhes.component';
import { RespostaComponent } from './components/mentoria/resposta/resposta.component';
import { CriarQuestaoComponent } from './components/mentoria/criar-questao/criar-questao.component';
import { EscolhaDesafioComponent } from './components/participante/escolha-desafio/escolha-desafio.component';
import { ResumoEquipeComponent } from './components/participante/resumo-equipe/resumo-equipe.component';
import { EquipeslistComponent } from './components/participante/equipeslist/equipeslist.component';
import { AvaliadorComponent } from './components/avaliador/avaliador.component';
import { QuestaoComponent } from './components/mentoria/questao/questao.component';


const routes: Routes = [
  { path: 'detalhes', component: DetalhesComponent },
  { path: 'perfil', component: MudarPerfilComponent },

  { path: 'mentoria', component: QuestaoComponent },
  { path: 'mentoria/criar-topico', component: CriarQuestaoComponent },
  { path: 'mentoria/topico/:questaoId', component: RespostaComponent },

  { path: 'avaliacoes', component: AvaliadorComponent },

  { path: 'equipes', component: EquipeslistComponent },

  { path: 'equipe/:nomeEquipe', component: ResumoEquipeComponent },
  { path: 'desafios/:nomeEquipe', component: EscolhaDesafioComponent },
  { path: 'entregas/:nomeEquipe', component: EntregaslistComponent },
  { path: '', component: LoginComponent },
  { path: '**', redirectTo: '/' },
  { path: '',   redirectTo: '/', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
